<template>
<v-container fluid>
    <v-row>
        <v-col>
            <ag-grid-vue 
                :style="{width: '100%', height: this.gridHeight + 'px'}"
                class="ag-theme-alpine"
                :columnDefs="columnDefs"
                :rowData="rows"
            />
        </v-col>
    </v-row>

</v-container>
</template>

<script>
import 'ag-grid-community/dist/styles/ag-grid.css'
import 'ag-grid-community/dist/styles/ag-theme-alpine.css'
import { AgGridVue } from 'ag-grid-vue'


export default {
    name: "FileContents",
    components: {AgGridVue},
    props: {
        rows: Array,
    },
    mounted () {
      this.gridHeight = window.innerHeight - 240
      window.addEventListener('resize', () => {
        this.gridHeight = window.innerHeight - 240
      })
    },
    unmounted () {
        window.removeEventListener('resize')
    },
    data () {
        return {
            gridHeight: 400,
            columnDefs: [
                { headerName: "Domain Name", field: "domain_name", sortable: true },
                { headerName: "Coseller / Customer", field: "type", sortable: true, filter: 'agTextColumnFilter' },
                { 
                    headerName: "Message", 
                    field: "message", 
                    sortable: true, 
                    filter: 'agTextColumnFilter',
                    cellStyle: params => {
                        let status = params.value ? params.value.toLowerCase() : params.value
                        status = status && status.includes('added') ? 'added' : status && status.includes('prohibited') ? 'prohibited' : status
                        const colors = {
                            'not found': {color: 'white', backgroundColor: 'orangered'},
                            'prohibited': {color: 'white', backgroundColor: 'orangered'},
                            'already existed': {color: 'black', backgroundColor: 'gold'},
                            'added': {color: 'black', backgroundColor: 'mediumseagreen'},
                        }
                        return colors[status]
                    }
                },
            ]
        }
    }
}
</script>